// 2020/03/13 - adding prod. 
// When a limited product is added to the cart from the collection page's quickview, disable the add to cart button when the limit is reached
function plusCollectionAdd (event) {
  var plus_variant_id = event.data.param1;
  var plus_limit = event.data.param2;
  var plus_msg = event.data.param3;
  // console.info('plusCollectionAdd - '+plus_msg+' - '+plus_limit);
  setTimeout(function() {
    $.ajax({
      async: false,
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function (data) {
        var length = data.items.length;
        for (var i=0; i<length; i++) {
          // console.info('plusCollectionAdd - '+i);
          if (data.items[i].variant_id == plus_variant_id) {
            plus_remaining = (plus_limit - data.items[i].quantity);
            if (plus_remaining < 1) {
              // console.info('collecion');
              $('#plus_limited-'+plus_variant_id).attr('disabled','disabled').html(plus_msg).addClass('Button--secondary').removeClass('Button--primary');
            }
          }
        }
      }
    });
  },1000);
}

// When the limited product is at its limit, set the quantity selector's only valid input to 0
function plusProductOverLimit(plus_variant_id, plus_limit) {
  console.info('****** Over limit ****** - start');
  var variant_id = plus_variant_id;
  var limit = plus_limit;
  $('input.QuantitySelector__CurrentQuantity').val(0).attr('pattern','[]{0}');
  plusProductChange(variant_id,limit);
  // console.info('****** Over limit ****** - end');
}

// When the limited product is under the limit, set the quantity selector to accept any number between 0 and the limit
function plusProductUnderLimit(item_quantity, plus_variant_id, plus_limit) {
  // console.info('****** limit ****** - '+plus_limit+' - '+plus_variant_id+' - '+item_quantity);
  var plus_remaining = (plus_limit - item_quantity);
  $('input.QuantitySelector__CurrentQuantity').attr('pattern','[0-'+plus_remaining+']{1}');
}

// product page
// When the limited product gets added to the cart, if it is under the limit, set the quantity selector to accept any number between 0 and the limit
function plusProductAdd(event) {
  var plus_variant_id = event.data.param1;
  var plus_limit = event.data.param2;
  // console.info('plusProductAdd - '+event.data.param2+' - '+event.data.param1);
  setTimeout(function() {
    $.ajax({
      async: false,
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function (data) {
        var length = data.items.length;
        for (var i=0; i<length; i++) {
          if (data.items[i].variant_id == plus_variant_id){
            plus_remaining = (plus_limit - data.items[i].quantity);
            // $('input.QuantitySelector__CurrentQuantity').attr('pattern','[0-'+plus_remaining+']{1}');
            if (plus_remaining == 0) {
              // console.info('variant est dans le panier if - '+plus_remaining);
              $('input.QuantitySelector__CurrentQuantity').val(0).attr('pattern','[]{0}');
              $('button.ProductForm__AddToCart').attr('disabled','disabled');
              $('button.ProductForm__AddToCart').css({'cursor' : 'not-allowed', 'pointer-events' : 'none'});
              return;
            } else {
              // console.info('variant est dans le panier else - '+plus_remaining);
              $('input.QuantitySelector__CurrentQuantity').val(1).attr('pattern','[0-'+plus_remaining+']{1}');
              return;
            }
          }
        }
      }
    });
  },1000);
}

// dev. functionn to check the variant qty when you changing it on product page÷
function plusProductChange(variant_id,limit) {
  var plus_variant_id = variant_id;
  var plus_limit = limit;
  // console.info('plusProductChange - '+variant_id+' - '+limit);
  setTimeout(function() {
    $.ajax({
      async: false,
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function (data) {
        var length = data.items.length;
        // console.info('length - '+length);
        for (var i=0; i<length; i++) {
          // console.info('variant panier - '+data.items[i].variant_id+' - variant produit - '+plus_variant_id);
          if (data.items[i].variant_id == plus_variant_id){
            // console.info('variant est dans le panier');
            plus_remaining = (plus_limit - data.items[i].quantity);
            if (plus_remaining == 0) {
              // console.info('variant est dans le panier if - '+plus_remaining);
              $('input.QuantitySelector__CurrentQuantity').val(0).attr('pattern','[]{0}');
              $('button.ProductForm__AddToCart').attr('disabled','disabled');
              $('button.ProductForm__AddToCart').css({'cursor' : 'not-allowed', 'pointer-events' : 'none'});
              return;
            } else {
              // console.info('variant est dans le panier else - '+plus_remaining);
              $('input.QuantitySelector__CurrentQuantity').val(1).attr('pattern','[0-'+plus_remaining+']{1}');
              return;
            }
          } else {
            // console.info('variant n\'est pas dans le panier');
            $('input.QuantitySelector__CurrentQuantity').val(1).attr('pattern','[0-'+plus_limit+']{1}');
          }
        }
      }
    });
  },1000);
}

// When the cart page quantity selector gets increased over a product's limit, disable the checkout button and remove over limit items from the cart
// When the selector is at the limit, disable the + button so it can't be increased that way

function plusCartLimit(plus_id,plus_limit) {
  // console.info('plusCartLimit - '+plus_id+' - '+plus_limit)
  if ($('.plus-quantity-with-limit .QuantitySelector__CurrentQuantity').val() > plus_limit) {
    $('button.Cart__Checkout').attr('disabled','disabled');
    $('button.Cart__Checkout').css({'cursor' : 'not-allowed', 'pointer-events' : 'none'});
    jQuery.post('/cart/update.js','updates['+plus_id+']='+plus_limit+'');
    // console.info('if - '+plus_id)
  } else if ($('.plus-quantity-with-limit .QuantitySelector__CurrentQuantity').val() == plus_limit) {
    $('.plus-quantity-with-limit .QuantitySelector__Button[data-quantity="'+plus_limit+'"]').each(function(){
      $(this).css({"color":"#cfcfcf","cursor":"not-allowed","pointer-events":"none"});
    })
    // $('.plus-quantity-with-limit .QuantitySelector__Button').eq(1).css({"color":"#cfcfcf","cursor":"not-allowed","pointer-events":"none"});
    // $('.plus-quantity-with-limit .QuantitySelector__Button').eq(3).css({"color":"#cfcfcf","cursor":"not-allowed","pointer-events":"none"});
    // console.info('else - '+plus_id)
  }
}
